import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { progress } from '../animations';
import { viewport } from '../getViewport';
import Swiperslider from 'modules/swiper/swiper';

export const storyTeaser = () => {
  const storyTeaser = $$('.story-teaser');

  if (storyTeaser.length) {
    storyTeaser.forEach(teaser => {
      const timelineFirst = gsap.timeline();

      gsap.set(teaser, {
        '--filter-value': viewport.isReduced ? '1' : '3',
        scale: viewport.isReduced ? 1 : 0.7,
        y: viewport.isReduced ? 0 : 100,
      });

      timelineFirst.to(teaser, {
        scale: 1,
        '--filter-value': () => 1,
        y: 0,
      });

      ScrollTrigger.create({
        animation: timelineFirst,
        trigger: teaser,
        start: () => 'top bottom',
        end: () => 'top 75%',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });

      const timelineSecond = gsap.timeline();
      const video = $('.story-teaser__video', teaser);

      ScrollTrigger.create({
        animation: timelineSecond,
        trigger: teaser,
        start: () => 'top bottom',
        end: () => 'bottom bottom',
        onEnter: () => {
          video.play();
        },
        toggleActions: 'play pause resume reset',
        onUpdate: self => progress(self),
      });

      const slider = new Swiperslider($('.story-teaser__heading', teaser), {
        container: teaser,
        sliderOptions: {
          spaceBetween: 160,
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: 'true',
          },
        },
      });
      slider.init();
    });
  }
};
